import React, { useState } from 'react';
import ReactJson from 'react-json-view';
import Api from '../services/api';
import Web3Nova from '../services/web3Nova';
import TokenMetadataViewProp from './properties/token-metadata-view';
import { LoadingStatusEnum } from '../enums/LoadingStatusEnum';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function TokenMetaDataView({
  contract, setStatusMessage, onLoadingStatusChanged,
} :TokenMetadataViewProp):
  React.ReactElement {
  const [tokenId, setTokenId] = useState('');
  const [metaData, setMetaData] = useState({});
  const [metaDataUrl, setMetaDataUrl] = useState('');

  const validate = () => {
    if (!tokenId || tokenId.trim().length === 0) {
      setStatusMessage('Please enter token id', StatusMessageTypeEnum.error);
      return false;
    }
    return true;
  };

  const getMetaDataUrl = (token:string) => {
    const web3Nova = new Web3Nova(contract.blockchain);
    web3Nova.getTokenUri(contract.address, contract.standard, token).then((url) => {
      setMetaDataUrl(url);
      Api.getMetaData(url).then((data) => {
        setMetaData(data);
        onLoadingStatusChanged(LoadingStatusEnum.loaded);
      }).catch((reason) => {
        onLoadingStatusChanged(LoadingStatusEnum.loaded);
        setStatusMessage(reason.message, StatusMessageTypeEnum.error);
        console.log(reason.messasge);
      });
    }).catch((error) => {
      console.log(error);
      onLoadingStatusChanged(LoadingStatusEnum.loaded);
      setStatusMessage(error.message, StatusMessageTypeEnum.error);
    });
  };

  const handleMetaDataSubmit = (event:any) => {
    event.preventDefault();
    setStatusMessage('', StatusMessageTypeEnum.none);
    if (validate()) {
      onLoadingStatusChanged(LoadingStatusEnum.loading);
      getMetaDataUrl(tokenId);
    }
  };

  return (
    <div className="row">
      <div className="col">
        <form onSubmit={handleMetaDataSubmit}>
          <div>
            <span className="me-2 form-label fw-bold">Blockchain:</span>
            <span className="text-capitalize">{contract.blockchain}</span>
          </div>
          <div>
            <span className="me-2  form-label fw-bold">Contract Address:</span>
            <span className="address">{contract.address}</span>
          </div>
          <label htmlFor="assetKey" className="form-label w-100">
            Token Id
            <input
              type="text"
              id="tokenId"
              className="form-control mt-1 d-block"
              value={tokenId}
              onChange={(e) => {
                setTokenId(e.target.value);
              }}
            />
            <span className="text-sm-light fst-italic p-1 d-block" />
          </label>
          <h6 className="mt-1 fw-bold fst-italic" style={{ fontSize: '14px' }}>
            Meta Data Url
          </h6>
          <div className="fst-italic mb-3">
            <a className="text-break" href={metaDataUrl}>
              {metaDataUrl}
            </a>
          </div>
          <div className="mt-2 mb-3">
            <ReactJson src={metaData} style={{ width: '100%', padding: '10px', wordBreak: 'break-all' }} collapsed theme="apathy:inverted" />
          </div>
          <button type="submit" className="btn btn-dark me-2 ">Get Meta Data</button>
        </form>
      </div>
    </div>
  );
}

export default TokenMetaDataView;
